var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "transfer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2679",
    "data-name": "Path 2679",
    d: "M19.714,0H4.286A4.291,4.291,0,0,0,0,4.286V19.714A4.291,4.291,0,0,0,4.286,24H19.714A4.291,4.291,0,0,0,24,19.714V4.286A4.291,4.291,0,0,0,19.714,0Zm1.509,10.844a.855.855,0,0,1-.093.093l-6,5.143a.857.857,0,0,1-1.415-.651V12.857H8.571A.857.857,0,0,1,7.714,12V10.641L4.641,13.714l3.074,3.074V15.429a.857.857,0,0,1,.857-.857h2.571a.857.857,0,1,1,0,1.714H9.429v2.571a.857.857,0,0,1-.529.792.847.847,0,0,1-.328.065.857.857,0,0,1-.606-.25L2.823,14.321a.857.857,0,0,1,0-1.212h0L7.965,7.965a.857.857,0,0,1,1.463.606v2.571h5.143a.857.857,0,0,1,.857.857v1.566l3.825-3.28L15.429,7.007V8.571a.857.857,0,0,1-.857.857H12a.857.857,0,1,1,0-1.714h1.714V5.143a.857.857,0,0,1,1.415-.651l6,5.143A.857.857,0,0,1,21.223,10.844Z",
    fill: "#fac668"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrade);
export default __webpack_public_path__ + "static/media/trade.79055ef3.svg";
export { ForwardRef as ReactComponent };